/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form } from "antd";

import { Typography, Input, Button } from "@atoms";
import { theme } from "@theme";
import { useLogin } from "hooks";
import { Container, FormParent, ForgotPassword, Wrapper } from "./login.styles";

function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const { login, isLoading, isError, resetError } = useLogin();

  const handleClick = () => {
    login(email, password);
  };

  useEffect(() => {
    if (isError) {
      form.setFields([
        {
          name: "email",
          errors: [t("loginError")],
        },
        {
          name: "password",
          errors: [""],
        },
      ]);
    }
  }, [isError]);

  const handleValuesChange = async () => {
    form
      .validateFields()
      .then((res) => {
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(!!err.errorFields.length);
      });

    resetError();
  };

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Enter") handleClick();
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [email, password]);

  return (
    <Wrapper>
      <Container>
        <Typography as="h2">{t("login")}</Typography>
        <Form
          style={{ width: "100%" }}
          form={form}
          layout="vertical"
          onValuesChange={handleValuesChange}
          requiredMark={false}
        >
          <FormParent>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: t("writeEmail") },
                {
                  type: "email",
                  message: t("emailError"),
                },
              ]}
            >
              <Input
                name="email"
                form={form}
                value={email}
                onChange={setEmail}
                placeholder={t("writeEmail")}
              />
            </Form.Item>
            <Form.Item
              label={t("password")}
              name="password"
              rules={[
                { required: true, message: t("writePassword") },
                {
                  min: 8,
                  message: t("passwordError"),
                },
              ]}
            >
              <Input.Password
                name="password"
                form={form}
                value={password}
                onChange={setPassword}
                placeholder={t("writePassword")}
              />
            </Form.Item>
            <ForgotPassword
              isError={isError}
              onClick={() => navigate("/recovery")}
            >
              {t("forgotPassword")}
            </ForgotPassword>
          </FormParent>
        </Form>

        <Button
          variant="primary"
          size="large"
          fullWidth
          disabled={isDisabled}
          loading={isLoading}
          onClick={handleClick}
        >
          <Typography style={{ color: theme.palette.default }}>
            {t("continue")}
          </Typography>
        </Button>
        <Typography style={{ textAlign: "center" }}>
          {t("dontacc")}{" "}
          <Typography
            as="a"
            href="/register"
            style={{ color: theme.palette.primary, textDecoration: "none" }}
          >
            {t("register")}
          </Typography>
        </Typography>
      </Container>
    </Wrapper>
  );
}

export default Login;
